import {createSelector} from "reselect";
import {RolesState} from "./types";
import { RootState } from "..";


export const rootSelector: (state: RootState) => RolesState = (state: RootState) => state.roles;

export const rolesSelector = createSelector(rootSelector, (items) => items.roles);
export const roleSelector = (roleId : string) => createSelector(rootSelector, (items) => items.roles.find(role => role._id === roleId));
